import { consentDocumentBlocks } from "@emr/contracts";
import "./consent-document-text.css";

/**
 * A patient terms document as patients read it: headings, paragraphs and lists from
 * consentDocumentBlocks. The text is rendered as text, never as HTML, so markup in a body shows
 * as typed. Colours are inherited from the surface it sits in (a dialog or an admin card).
 */
export function ConsentDocumentText({ body }: { readonly body: string }) {
  return (
    <div className="consent-text">
      {consentDocumentBlocks(body).map((block, index) => {
        const key = `${index}:${block.kind}`;
        if (block.kind === "heading") return <h3 key={key}>{block.text}</h3>;
        if (block.kind === "paragraph") return <p key={key}>{block.text}</p>;
        return (
          <ul key={key}>
            {block.items.map((item, itemIndex) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: list items are an immutable split of one stored version.
              <li key={itemIndex}>{item}</li>
            ))}
          </ul>
        );
      })}
    </div>
  );
}
